var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"date-calendar-modal-footer"},[_c('span',{staticClass:"date-calendar-modal-footer__label"},[_vm._v(" "+_vm._s(_vm.dateCalendarModalFooter))]),_c('button',{staticClass:"button-v3 button-v3--primary",on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v(" Zamknij ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }